import * as angular from 'angular';

import { ActionExecutorService } from './mx-action-executor-service';
import { MxActionManagerService } from './mx-action-manager-service';
import { ActionProviderService } from './mx-action-provider-service';
import { ApplicationProviderService } from './mx-application-provider-service';
import { MxBackgroundProcessProvider } from './mx-background-process-provider';
import { MxTrackedProcessProvider } from './mx-tracked-process-provider';
import { MxBackgroundProcessesService } from './mx-background-processes-service';
import { MxContextService } from './mx-context-service';
import { DownloadHelpService } from './mx-download-help-service';
import { FeedbackProviderService } from './mx-feedback-provider-service';
import { MxInjectorService } from './mx-injector-service';
import { MxKeyboardNavigationService } from './mx-keyboard-navigation';
import { MxObjectMapper } from './mx-object-mapper';
import { SearchProviderService } from './mx-search-provider-service';
import { SideLayout } from './mx-side-layout-service';
import { SidePanelActionsService } from './mx-side-panel-actions-service';
import { SidePanelService } from './mx-side-panel-service';
import { SidebarService } from './mx-sidebar-service';
import { ShellAppInitializerService } from './shell-app.initializer.service';

import { routingConfiguration } from './mx-routing-configuration-service';

angular
	.module('mx.shell')
	.service('mx.shell.ActionExecutorService', ActionExecutorService)
	.service('mx.shell.ActionManagerService', MxActionManagerService)
	.service('mx.shell.ActionProviderService', ActionProviderService)
	.service('mx.shell.ApplicationProviderService', ApplicationProviderService)
	.service('mx.shell.BackgroundProcessProvider', MxBackgroundProcessProvider)
	.service('mx.shell.TrackedProcessProvider', MxTrackedProcessProvider)
	.service('mx.shell.BackgroundProcessesService', MxBackgroundProcessesService)
	.service('mx.shell.ContextService', MxContextService)
	.service('mx.shell.DownloadHelpService', DownloadHelpService)
	.factory('mx.shell.FeedbackProviderService', FeedbackProviderService)
	.service('mx.shell.InjectorService', MxInjectorService)
	.factory('mx.shell.KeyboardNavigationService', MxKeyboardNavigationService)
	.service('mx.shell.ObjectMapper', MxObjectMapper)
	.service('mx.shell.SearchProviderService', SearchProviderService)
	.factory('mx.shell.SideLayout', SideLayout)
	.factory('mx.shell.SidePanelActionsService', SidePanelActionsService)
	.service('mx.shell.SidePanelService', SidePanelService)
	.service('mx.shell.SidebarService', SidebarService)
	.service('mx.shell.ShellAppInitializerService', ShellAppInitializerService)

	.run(routingConfiguration);
